module.exports = "<app-generaltransaction-menu></app-generaltransaction-menu>\n<div class=\"clearfix\"></div>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/general-transaction/general-transaction.component.html
// module id = ./src/app/general-transaction/general-transaction.component.html
// module chunks = main